import * as actionTypes from './actionTypes';

export const markAsInstalled = () => {
    return {
        type: actionTypes.A2HS_SUCCESS
    };
}

export const storeAddToHomeScreenEvent = (event) => {
    return {
        type: actionTypes.A2HS_SAVE_EVENT, 
        event: event
    };
}

export const clearInstallEvent = () => {
    return {
        type: actionTypes.A2HS_CLEAR
    };
}